var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as maptilersdk from '@maptiler/sdk';
import RulerControl from '@mapbox-controls/ruler';
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Controller3DControl } from './Controller3DControl';
export class MapManager extends Component {
    constructor() {
        super('MapManger', false);
        this.apiKey = 'fY7qs72LEX4q8ckBcJ5v';
        this.mapStyleNeon = 'https://api.maptiler.com/maps/019e031a-a5d1-73df-ae10-a4592e6dec3d/style.json?key=fY7qs72LEX4q8ckBcJ5v';
        this.mapStyleLowkey = '';
        this.mapStyleClassic = 'https://api.maptiler.com/maps/019e031a-a5d1-73df-ae10-a4592e6dec3d/style.json?key=fY7qs72LEX4q8ckBcJ5v';
        this.isModifierPressed = false;
        this.isPerspectiveDragging = false;
        this.dragLastX = 0;
        this.dragLastY = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.mapElement = $('#map');
            this.initOptions();
            this.createMap();
            let markers = [];
            $('body').on('map::zoomTo', (event) => {
                if (markers.length > 0)
                    markers.forEach((marker) => marker.remove());
                this.map.flyTo({
                    center: event.detail.latlng,
                    zoom: event.detail.zoom,
                    speed: 1,
                    curve: 1,
                    easing: (t) => t
                });
                // add a marker to the map
                var element = document.createElement('div');
                element.className = 'marker';
                element.style.width = '25px';
                element.style.height = '40px';
                markers.push(new maptilersdk.Marker({ element, anchor: 'bottom' }).setLngLat(event.detail.latlng).addTo(this.map));
            });
            this.success();
        });
    }
    /*
     * Fetches the map options from the data attributes of the map element
     */
    initOptions() {
        this.options = {
            style: this.mapElement.data('style') ? this.mapElement.data('style') : 'full',
            lng: this.mapElement.data('lng') ? +this.mapElement.data('lng') : 138.6,
            lat: this.mapElement.data('lat') ? +this.mapElement.data('lat') : 35.5,
            zoom: this.mapElement.data('zoom') ? +this.mapElement.data('zoom') : 7.5,
            pitch: this.mapElement.data('pitch') ? +this.mapElement.data('pitch') : 0,
            bearing: this.mapElement.data('bearing') ? +this.mapElement.data('bearing') : 0,
            marker: false
        };
        if (this.mapElement.data('marker')) {
            if (this.mapElement.data('marker') === 'true') {
                this.options.marker = true;
            }
            else if (this.mapElement.data('marker') === 'false') {
                this.options.marker = false;
            }
            else {
                this.options.marker = this.mapElement.data('marker');
            }
        }
    }
    createMap() {
        maptilersdk.config.apiKey = this.apiKey;
        // Initialize the map
        this.map = new maptilersdk.Map({
            container: this.mapElement.get(0),
            style: this.mapStyleNeon,
            center: [this.options.lng, this.options.lat],
            zoom: this.options.zoom,
            pitch: this.options.pitch,
            bearing: this.options.bearing,
            scrollZoom: (this.options.style === 'full') ? true : false,
            geolocateControl: false,
            navigationControl: false,
            attributionControl: false,
        });
        this.bindPerspectiveDragInteraction();
        // Attribution
        /*this.map.addControl(new maptilersdk.AttributionControl({
          compact: true,
          customAttribution: '© Lionel Tardy'
        }));*/
        // Set controls
        this.add3DController(this.options.style === 'full' ? 'bottom-left' : 'top-right');
        this.map.addControl(new maptilersdk.NavigationControl({ showCompass: false }), this.options.style === 'full' ? 'bottom-left' : 'top-left');
        if (this.options.style === 'full') {
            if ($('body').hasClass('is-admin')) {
                this.map.addControl(this.createStylesControl(), 'bottom-right');
            }
            this.map.addControl(new RulerControl({
                labelLayout: {
                    'text-field': ['get', 'distance'],
                    'text-font': ['Noto Sans Regular'],
                }
            }), 'bottom-right');
        }
        // Enable 3D terrain
        this.map.on('load', () => {
            this.set3DTerrain(this.map);
        });
        // Set map location
        let location = [this.options.lng, this.options.lat];
        // Add a marker to the map
        if (this.options.marker) {
            if (typeof this.options.marker !== 'boolean') {
                const rawLocation = this.options.marker.split(',');
                location = [+rawLocation[0], +rawLocation[1]];
            }
            new maptilersdk.Marker({ element: $.parseHTML('<div class="marker"></div>').get(0), anchor: 'bottom' }).setLngLat(location).addTo(this.map);
        }
        // Console output for debugging
        this.map.on('move', () => {
            if ($('body').hasClass('is-admin'))
                console.log(this.map.getCenter(), this.map.getZoom(), this.map.getBearing(), this.map.getPitch());
        });
    }
    bindPerspectiveDragInteraction() {
        const canvasContainer = this.map.getCanvasContainer();
        const updateModifierState = (event) => {
            this.isModifierPressed = event.ctrlKey || event.metaKey;
            if (!this.isModifierPressed && this.isPerspectiveDragging) {
                this.stopPerspectiveDragging();
            }
        };
        window.addEventListener('keydown', updateModifierState);
        window.addEventListener('keyup', updateModifierState);
        window.addEventListener('blur', () => {
            this.isModifierPressed = false;
            this.stopPerspectiveDragging();
        });
        canvasContainer.addEventListener('mousedown', (event) => {
            const isLeftClick = event.button === 0;
            const hasModifier = event.ctrlKey || event.metaKey;
            if (!isLeftClick || !hasModifier)
                return;
            event.preventDefault();
            this.startPerspectiveDragging(event.clientX, event.clientY);
        });
        window.addEventListener('mousemove', (event) => {
            if (!this.isPerspectiveDragging)
                return;
            event.preventDefault();
            const deltaX = event.clientX - this.dragLastX;
            const deltaY = event.clientY - this.dragLastY;
            this.dragLastX = event.clientX;
            this.dragLastY = event.clientY;
            const nextPitch = this.clamp(this.map.getPitch() - (deltaY * 0.4), 0, 90);
            const nextBearing = this.map.getBearing() + (deltaX * 0.35);
            this.map.setPitch(nextPitch);
            this.map.setBearing(nextBearing);
        });
        window.addEventListener('mouseup', () => {
            this.stopPerspectiveDragging();
        });
    }
    startPerspectiveDragging(x, y) {
        this.isPerspectiveDragging = true;
        this.dragLastX = x;
        this.dragLastY = y;
        this.map.dragPan.disable();
        this.map.getCanvas().style.cursor = 'grabbing';
    }
    stopPerspectiveDragging() {
        if (!this.isPerspectiveDragging)
            return;
        this.isPerspectiveDragging = false;
        this.map.dragPan.enable();
        this.map.getCanvas().style.cursor = '';
    }
    clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }
    set3DTerrain(map, styleName) {
        map.enableTerrain(1.2);
    }
    createStylesControl() {
        const stylesData = [
            { label: 'Neon', styleName: 'kanako-neon', styleUrl: this.mapStyleNeon },
            { label: 'Low', styleName: 'kanako-lowtech', styleUrl: this.mapStyleLowkey },
            { label: 'Test', styleName: 'kanako-classic', styleUrl: this.mapStyleClassic },
        ];
        const onStyleChange = (style) => {
            if (!style.styleUrl)
                return;
            setTimeout(() => this.set3DTerrain(this.map, style.styleName), 2000);
        };
        const self = this;
        const buttons = [];
        let container;
        return {
            onAdd(map) {
                container = document.createElement('div');
                container.classList.add('mapboxgl-ctrl', 'mapboxgl-ctrl-group', 'mapbox-ctrl-styles', 'mapbox-ctrl-styles-expanded');
                stylesData.forEach(style => {
                    const button = document.createElement('button');
                    button.type = 'button';
                    button.title = style.label;
                    button.textContent = style.label;
                    button.addEventListener('click', () => {
                        if (!style.styleUrl || button.classList.contains('-active'))
                            return;
                        buttons.forEach(b => b.classList.remove('-active'));
                        button.classList.add('-active');
                        self.map.setStyle(style.styleUrl);
                        onStyleChange(style);
                    });
                    buttons.push(button);
                    container.appendChild(button);
                });
                buttons[0].classList.add('-active');
                return container;
            },
            onRemove() {
                var _a;
                (_a = container === null || container === void 0 ? void 0 : container.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(container);
            }
        };
    }
    add3DController(position = 'bottom-left') {
        const controller3DControl = new Controller3DControl();
        this.map.addControl(controller3DControl, position);
        if (this.options.pitch != 0) {
            $(controller3DControl.container).addClass('active');
            controller3DControl.is3dActive = true;
        }
    }
}
